import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

export default function LoginButton({ className, currentLocation }) {
  const isLoginPage = currentLocation.pathname === '/login';

  if (isLoginPage) {
    return (
      <span className={`${className} btn-disabled`}>
        Log in
      </span>
    );
  }

  return (
    <Link
      to="/login"
      className={className}
    >
      Log in
    </Link>
  );
}

LoginButton.propTypes = {
  currentLocation: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};
